<mat-select [formControl]="valueControl" [placeholder]="placeholder" [multiple]="multiple">
  <mat-select-trigger>
   {{getTriggerText(valueControl.value)}}
  </mat-select-trigger>
  <mat-option>
    <ngx-mat-select-search [formControl]="filterControl" [placeholderLabel]="placeholderLabel"
      [noEntriesFoundLabel]="noEntriesFoundLabel">
    </ngx-mat-select-search>
  </mat-option>
  <mat-option *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </mat-option>
  <mat-option *ngFor="let item of options | async" [value]="valueKey ? item[valueKey]: item">

    <ng-template [ngIf]="!optionTemplate">
      {{getDisplayText(item)}}
    </ng-template>

    <ng-template [ngIf]="optionTemplate" *ngTemplateOutlet="optionTemplate; context: {$implicit: item}">
    </ng-template>
  </mat-option>

</mat-select>